module.exports = __webpack_public_path__ + "static/media/files-medical.0ee97de4.svg";